// define page validators and routes to go to when valid ordered from the first to last page in the quote flow
const quotePageFlow = {
  quoteDetailsValid: 'quoteCarVariants',
  quoteVariantValid: 'quoteLeaseDetails',
  quoteLeaseValid: 'quoteColourAndExtras',
  quoteColourAndExtrasValid: 'quoteOrderDetails',
  quoteOrderDetailsValid: 'quoteReview'
};

export default {
  quote(state) {
    return state.quote;
  },
  saveQuoteFields(state, getters, rootState) {
    return {
      orgId: rootState.auth.user.organisation.id,
      dbQuoteId: state.quote.dbquote.id,
      erpQuoteRef: state.quote.erpquote.erpQuoteRef
    };
  },
  isAwaitingPrice(state) {
    return state.quote.dbquote.quote_status_code === 'AWAITINGPRICING';
  },
  hasRequestedPricing(state) {
    let pricingStatuses = ['AWAITINGPRICING', 'PRICINGRECEIVED'];
    return pricingStatuses.includes(state.quote.dbquote.quote_status_code);
  },
  isSubmitting(state) {
    return state.quote.dbquote.quote_status_code === 'SUBMITTED';
  },
  isAccepted(state) {
    return state.quote.dbquote.quote_status_code === 'ACCEPTED';
  },
  isExpired(state) {
    return state.quote.dbquote.quote_status_code === 'EXPIRED';
  },
  // Authentications
  canRead(state, getters, rootState) {
    if (!rootState.auth.user) {
      return false;
    }
    return rootState.auth.user.features.find(
      (feature) => feature.code === 'DB::ReadQuote'
    );
  },
  canCreate(state, getters, rootState) {
    if (!rootState.auth.user) {
      return false;
    }
    return rootState.auth.user.features.find(
      (feature) => feature.code === 'DB::CreateQuote'
    );
  },
  // Validations
  // Return true if the quote flow passes all pages up to the given point in the flow
  flowValidUntil: (state, getters) => (flowStop) => {
    let flow = Object.keys(quotePageFlow);
    for (let i = 0; i < flow.length; i++) {
      if (flow[i] === flowStop) {
        return true;
      }

      if (!getters[flow[i]]) {
        return false;
      }
    }
  },
  // Validation States
  quoteDetailsValid: (state) => {
    return Boolean(
      state.quote.erpquote.product.id &&
        state.quote.erpquote.make.id &&
        state.quote.erpquote.bodyType.id
    );
  },
  quoteVariantValid: (state, getters) => {
    return Boolean(
      getters.flowValidUntil('quoteVariantValid') &&
        state.quote.erpquote.model.id &&
        state.quote.erpquote.variant.id
    );
  },
  quoteLeaseValid: (state, getters) => {
    return Boolean(
      getters.flowValidUntil('quoteLeaseValid') &&
        state.quote.erpquote.leaseTerm !== null &&
        state.quote.erpquote.kmsPerYear !== null &&
        state.quote.erpquote.leaseStart &&
        state.quote.erpquote.leaseEnd
    );
  },
  quoteColourAndExtrasValid: (state, getters) => {
    return Boolean(
      getters.flowValidUntil('quoteColourAndExtrasValid') &&
        state.quote.erpquote.exteriorColour.id &&
        state.quote.erpquote.interiorColour.id
    );
  },
  quoteOrderDetailsValid: (state, getters) => {
    return Boolean(
      getters.flowValidUntil('quoteOrderDetailsValid') &&
        state.quote.erpquote.customer.companyName &&
        state.quote.erpquote.customer.companyAbn &&
        state.quote.erpquote.customer.customerName &&
        state.quote.erpquote.customer.customerContactNumber &&
        state.quote.erpquote.customer.customerContactEmail &&
        state.quote.erpquote.customer.deliveryAddressLine1 &&
        state.quote.erpquote.customer.deliverySuburb &&
        state.quote.erpquote.customer.deliveryState &&
        state.quote.erpquote.customer.deliveryPostcode &&
        state.quote.erpquote.customer.deliveryDate &&
        state.quote.erpquote.customer.dealership &&
        state.quote.erpquote.customer.registrationPostcode
    );
  },
  // Return the first page in the quote flow that is incomplete
  firstIncompletePage: (state, getters) => {
    let flow = Object.keys(quotePageFlow).reverse();
    for (let i = 0; i < flow.length; i++) {
      if (getters[flow[i]]) {
        return quotePageFlow[flow[i]];
      }
    }
    return 'quoteCarDetails';
  }
};
